const ResultsRow = ({ data, className }) => (
  <tr>
    <td className={className}>{data.application_id}</td>
    <td className={className}>{data.name}</td>
    <td className={className}>{data.date_received}</td>
    <td className={className}>{data.decision}</td>
    <td className={className}>{data.amount_applied}</td>
    <td className={className}>{data.amount_approved}</td>
    <td className={className}>{data.purpose}</td>
    <td className={className}>{data.round_name}</td>
  </tr>
);

export default ResultsRow;
